module.exports = __webpack_public_path__ + "img/logo-imi-blanco-230x56.bc95b15f.png";